module.exports = __webpack_public_path__ + "img/zxq.ac41f05c.png";